import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { UpdateInstanceRequestModel } from '../../apis/v1/instances/model';
import { getErrorMessage } from '@xver/utils/error';
import { INSTANCE_LIST_QUERY_KEY } from './useInstanceListQuery';

export function useUpdateInstanceMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }: { id: number; data: UpdateInstanceRequestModel }) =>
            Endpoints.v1.Instances.updateInstance(id, data),
        onSuccess: (_res, vars) => {
            queryClient.invalidateQueries({ queryKey: INSTANCE_LIST_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: ['api.v1.instances.get', vars.id] });
            notifications.show({
                title: t('instance.updatedTitle'),
                message: t('instance.updatedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('instance.updateFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
